import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getAkamaiDomainSelector = createConfigSelector('akamaiDomain');
export const getEwpDomainSelector = createConfigSelector('ewpDomain');
export const getOneCMSDomainSelector = createConfigSelector('oneCMSInternetSSRBaseUrl');
export const getFaasApiUrlSelector = createConfigSelector('faasApiUrl');
